function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#close_red_svg__clip0_193_10340)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11 22c6.075 0 11-4.925 11-11S17.075 0 11 0 0 4.925 0 11s4.925 11 11 11z",
  fill: "#F4615D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.43 17.12a1.76 1.76 0 01-1.285-.55c-.99-.998-1.99-1.988-2.976-2.99-.136-.137-.205-.134-.339.001-.997 1.011-2 2.018-3.009 3.017-.737.73-1.879.687-2.528-.082-.576-.683-.534-1.67.114-2.325.94-.95 1.887-1.893 2.831-2.838.234-.234.233-.469-.002-.704-.949-.951-1.904-1.895-2.845-2.854-.89-.908-.535-2.44.655-2.821.677-.217 1.284-.061 1.79.445 1 .998 2.001 1.997 2.994 3.003.132.134.201.141.338.003.997-1.012 2-2.018 3.009-3.018.785-.778 2.018-.673 2.63.213.478.693.384 1.59-.243 2.222-.985.994-1.972 1.985-2.969 2.968-.156.155-.153.233.001.385 1.006.993 2.005 1.992 2.998 2.998.7.71.686 1.782-.02 2.462a1.653 1.653 0 01-1.144.465z",
  fill: "#FEFEFE"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "close_red_svg__clip0_193_10340"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h22v22H0z"
})));

function SvgCloseRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgCloseRed;


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/close_red.svg
// module id = 1311
// module chunks = 10